// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul > li:last-child {
  position: absolute;
  bottom: 0;
  width: calc(100% - 3rem);
}
ul > li:last-child.clientVersion {
  bottom: 3rem !important;
}

ul > li:nth-last-child(2) {
  position: absolute;
  bottom: 9rem;
  width: calc(100% - 3rem);
}
ul > li:nth-last-child(2).clientVersion {
  bottom: 12rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/app.menu.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AACJ;AACI;EACI,uBAAA;AACR;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,wBAAA;AAAJ;AAEI;EACI,wBAAA;AAAR","sourcesContent":["ul > li:last-child {\n    position: absolute;\n    bottom: 0;\n    width: calc(100% - 3rem);\n\n    &.clientVersion {\n        bottom: 3rem !important;\n    }\n}\n\nul > li:nth-last-child(2) {\n    position: absolute;\n    bottom: 9rem;\n    width: calc(100% - 3rem);\n\n    &.clientVersion {\n        bottom: 12rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
